import { Component } from "@angular/core";
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'loading-modal',
    templateUrl: 'loading-modal.component.html',
    styleUrls: ['loading-modal.component.scss']
})
export class LoadingModalComponent {

    constructor(
        private bsModalRef: BsModalRef
    ) { }
}